import { api } from "@/axios";
import responseHandler from "@/responseHandler.js";

const state = {
  messages: [],
};

const getters = {
  getMessages: (state) => state.messages,
  getMessageById: (state) => (id) => state.messages.find((x) => x.id == id),
};

const actions = {
  async fetchMessages({ commit }) {
    try {
      const resp = await api.get("/messages");
      if (resp.status == 200) {
        const messages = resp.data.data;
        commit("setMessages", messages);
      }
    } catch (error) {
      console.log("error", error);
      return false;
    }
  },
  async updateMessage({ commit }, message) {
    try {
      const id = message.id;
      message._method = "patch";
      const resp = await api.post(`/messages/${id}`, message);
      if (resp.status == 200) {
        const message = resp.data.data;
        commit("updateMessage", message);
      }
      return responseHandler.respH1(resp);
    } catch (error) {
      console.log("error", error);
      return responseHandler.respH1(error.response);
    }
  },
  async storeMessage({ commit }, message) {
    try {
      const resp = await api.post(`/messages`, message);
      if (resp.status == 201) {
        const message = resp.data.data;
        commit("storeMessage", message);
      }
      console.log("resp", resp);
      return responseHandler.respH1(resp);
    } catch (error) {
      return responseHandler.respH1(error.response);
    }
  },
  async deleteMessage({ commit }, id) {
    try {
      const resp = await api.delete(`/messages/${id}`);

      if (resp.status == 203) {
        commit("deleteMessage", id);
      }
      return responseHandler.respH1(resp);
    } catch (error) {
      return responseHandler.respH1(error.response);
    }
  },
};

const mutations = {
  setMessages(state, messages) {
    state.messages = messages;
  },
  updateMessage(state, message) {
    const id = message.id;

    const index = state.messages.findIndex((message) => message.id == id);
    if (index !== -1) {
      state.messages[index] = message;
    }
  },
  storeMessage(state, message) {
    state.messages.unshift(message);
  },

  deleteMessage(state, id) {
    const index = state.messages.findIndex((p) => p.id == id);
    if (index !== -1) {
      state.messages.splice(index, 1);
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
